// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown_dropdown__W6FB5","item":"dropdown_item__rR8Dg"};